import styles from "./Stars.module.scss";

export default function Stars(props: any) {
    return <div className={styles.bg}>
        <div className={styles.night}>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
            <div className={styles.shooting_star}></div>
        </div>
    </div> ;
}